import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* ================= FETCH COLORS ================= */
export const fetchColors = createAsyncThunk(
  "color/fetch",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const res = await api.get(
        `/api/colors?page=${page}&limit=${limit}`
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch colors");
    }
  }
);

/* ================= CREATE COLOR ================= */
export const createColor = createAsyncThunk(
  "color/create",
  async (payload, thunkAPI) => {
    try {
      const res = await api.post(
        `/api/colors`,
        payload
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to create color"
      );
    }
  }
);

/* ================= UPDATE COLOR ================= */
export const updateColor = createAsyncThunk(
  "color/update",
  async ({ id, ...payload }, thunkAPI) => {
    try {
      const res = await api.put(
        `/api/colors/${id}`,
        payload
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to update color"
      );
    }
  }
);

/* ================= DELETE COLOR ================= */
export const deleteColor = createAsyncThunk(
  "color/delete",
  async (id, thunkAPI) => {
    try {
      await api.delete(`/api/colors/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to delete color");
    }
  }
);

export const toggleColorStatus = createAsyncThunk(
  "color/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(
        `/api/colors/${id}/status`
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

/* ================= SLICE ================= */
const colorSlice = createSlice({
  name: "color",
  initialState: {
    colors: [],
    loading: false,
    error: null,
    pagination: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      /* FETCH */
      .addCase(fetchColors.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchColors.fulfilled, (state, action) => {
        state.loading = false;
        state.colors = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchColors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* CREATE */
      .addCase(createColor.fulfilled, (state, action) => {
        state.colors.unshift(action.payload);
      })

      /* UPDATE */
      .addCase(updateColor.fulfilled, (state, action) => {
        const index = state.colors.findIndex(
          (c) => c._id === action.payload._id
        );
        if (index !== -1) {
          state.colors[index] = action.payload;
        }
      })

      /* DELETE */
      .addCase(deleteColor.fulfilled, (state, action) => {
        state.colors = state.colors.filter(
          (c) => c._id !== action.payload
        );
      })

      /* TOGGLE STATUS */
      .addCase(toggleColorStatus.fulfilled, (state, action) => {
        const index = state.colors.findIndex(
          (c) => c._id === action.payload._id
        );
        if (index !== -1) {
          state.colors[index] = action.payload;
        }
      });
  }
});

export default colorSlice.reducer;
